// Zuwad AI assistant endpoints. Every call is scoped to the signed-in user's own threads.
const base = accountId =>
  `/api/v2/accounts/${accountId}/zuwad_assistant/threads`;
const data = request => request.then(response => response.data);

export default {
  threads: accountId => data(window.axios.get(base(accountId))),
  thread: (accountId, threadId) =>
    data(window.axios.get(`${base(accountId)}/${threadId}`)),
  createThread: accountId => data(window.axios.post(base(accountId), {})),
  renameThread: (accountId, threadId, title) =>
    data(window.axios.patch(`${base(accountId)}/${threadId}`, { title })),
  markSeen: (accountId, threadId) =>
    data(window.axios.post(`${base(accountId)}/${threadId}/seen`)),
  deleteThread: (accountId, threadId) =>
    window.axios.delete(`${base(accountId)}/${threadId}`),
  send: (accountId, threadId, content, files) => {
    const form = new FormData();
    form.append('content', content);
    files.forEach(file => form.append('images[]', file));
    return data(
      window.axios.post(`${base(accountId)}/${threadId}/messages`, form)
    );
  },
  stop: (accountId, threadId, messageId) =>
    data(
      window.axios.post(
        `${base(accountId)}/${threadId}/messages/${messageId}/stop`
      )
    ),
  approve: (accountId, threadId, messageId, choice) =>
    data(
      window.axios.post(
        `${base(accountId)}/${threadId}/messages/${messageId}/approval`,
        { choice }
      )
    ),
};
